import { apiWobaBackend } from "@/services/api-woba-backend";
import {
  GetPrivateRoomsProps,
  privateRoomData,
} from "./get-privaterooms.types";

export const GetPrivateRoomsApi = async ({
  offset,
  limit,
  others,
  orderBy,
}: GetPrivateRoomsProps) => {
  const searchParams = new URLSearchParams();
  searchParams.append("take", `${limit}`);
  searchParams.append("page", `${offset}`);

  if (orderBy && orderBy.direction) {
    const orderByDirection =
      orderBy.direction === "DESC" ? `-${orderBy.column}` : orderBy.column;
    searchParams.append("orderBy", `${orderByDirection}`);
  }

  Object.entries(others).map((item: any) => {
    if (item[1] !== null) {
      if (item[1] instanceof Array && item[1].length > 1) {
        item[1].map((value: any) => {
          searchParams.append(`${item[0]}[]`, `${value}`);
        });
      } else if (item[1] instanceof Array) {
        searchParams.append(`${item[0]}[]`, `${item[1]}`);
      } else {
        searchParams.append(`${item[0]}`, `${item[1]}`);
      }
    }
  });

  const { data } = await apiWobaBackend.get(
    `/private-offices/list?${searchParams.toString()}`,
  );

  const convertStringToArray = (text: string[]) => {
    if (text && !Array.isArray(text)) {
      const stringArrayToString = text as unknown as string;
      const stringToArray: Array<string> = stringArrayToString
        .split(",")
        .filter((text: string) => {
          return text !== "";
        });
      return stringToArray;
    }

    return text;
  };

  const getArrayPictures = (
    image0: string,
    image1: string,
    image2: string,
    image3: string,
    image4: string,
    image5: string,
  ) => {
    const pictures: Array<string> = [];

    if (image0) {
      pictures.push(image0);
    }
    if (image1) {
      pictures.push(image1);
    }
    if (image2) {
      pictures.push(image2);
    }
    if (image3) {
      pictures.push(image3);
    }
    if (image4) {
      pictures.push(image4);
    }
    if (image5) {
      pictures.push(image5);
    }

    return pictures;
  };

  const dataResponse = data as privateRoomData;

  const result = dataResponse.private_offices?.map((item) => {
    item.amenities = convertStringToArray(item?.amenities);
    item.extra_services = convertStringToArray(item?.extra_services);
    item.pictures = getArrayPictures(
      item.picture_url,
      item.picture_url1,
      item.picture_url2,
      item.picture_url3,
      item.picture_url4,
      item.picture_url5,
    );
    return item;
  });

  return {
    data: {
      private_rooms: dataResponse.private_offices,
      total: dataResponse.pagination.total,
      statistics: dataResponse.statistics,
      result,
    },
  };
};
